//
//  I00DIMLIGNEGAZI18n.js
//
//  Created by Sébastien Hecart on 2017-11-23 18:33:53 +0000.
//  Copyright © 2017 Sebastien Hecart. All rights reserved.
//

export default {
  I00DIMLIGNEGAZ_SECTION_0_TITLE: 'Calculez les diamètres de tuyauterie gaz de votre installation pour une ou plusieurs chaudières.',
  I00DIMLIGNEGAZ_in_pci: 'PCI',
  I00DIMLIGNEGAZ_res_densite_fictive: 'Densité fictive',
  I00DIMLIGNEGAZ_in_pressionGaz: 'Pression gaz',
  I00DIMLIGNEGAZ_in_temperatureGaz: 'Température gaz',
  I00DIMLIGNEGAZ_in_pressionAtmospherique: 'Pression atmosphérique',
  I00DIMLIGNEGAZ_SECTION_1_TITLE: '',
  I00DIMLIGNEGAZ_SECTION_1_TITLE_MAIL: 'Description du réseau',
  I00DIMLIGNEGAZ_in_nombreChaudiere: 'Nombre de chaudières raccordées',
  I00DIMLIGNEGAZ_in_nombreChaudiere_0: '1',
  I00DIMLIGNEGAZ_in_nombreChaudiere_1: '2',
  I00DIMLIGNEGAZ_in_nombreChaudiere_2: '3',
  I00DIMLIGNEGAZ_in_nombreChaudiere_3: '4',
  I00DIMLIGNEGAZ_in_puissanceChaudiere1: 'Chaudière 1',
  I00DIMLIGNEGAZ_in_puissanceChaudiere2: 'Chaudière 2',
  I00DIMLIGNEGAZ_in_puissanceChaudiere3: 'Chaudière 3',
  I00DIMLIGNEGAZ_in_puissanceChaudiere4: 'Chaudière 4',
  I00DIMLIGNEGAZ_SECTION_2_TITLE: 'Longueur collecteur principal',
  I00DIMLIGNEGAZ_in_longeurReseauPrincipal1: 'L1 compt - té ch1',
  I00DIMLIGNEGAZ_in_longeurReseauPrincipal2: 'L2 ch1 - té ch2',
  I00DIMLIGNEGAZ_in_longeurReseauPrincipal3: 'L3 ch2 - té ch3',
  I00DIMLIGNEGAZ_in_longeurReseauPrincipal4: 'L4 ch3 - té ch4',
  I00DIMLIGNEGAZ_SECTION_3_TITLE: 'Longueur branche(s) individuelle(s)',
  I00DIMLIGNEGAZ_in_longeurBranche1: 'L ch1',
  I00DIMLIGNEGAZ_in_longeurBranche2: 'L ch2',
  I00DIMLIGNEGAZ_in_longeurBranche3: 'L ch3',
  I00DIMLIGNEGAZ_in_longeurBranche4: 'L ch4',
  I00DIMLIGNEGAZ_SECTION_4_TITLE: 'Nombre accidents (vannes, coudes, …)',
  I00DIMLIGNEGAZ_in_nombreAccident1: 'Compteur à ch1',
  I00DIMLIGNEGAZ_in_nombreAccident2: 'Compteur à ch2',
  I00DIMLIGNEGAZ_in_nombreAccident3: 'Compteur à ch3',
  I00DIMLIGNEGAZ_in_nombreAccident4: 'Compteur à ch4',
  I00DIMLIGNEGAZ_SECTION_5_TITLE: 'Choix du type de canalisation',
  I00DIMLIGNEGAZ_in_gazMaterialIndex_Mail: 'Type de tuyauterie',
  I00DIMLIGNEGAZ_in_typeCalcul: '', //do not delete,required. auto generated code for empty title for segment
  I00DIMLIGNEGAZ_in_typeCalcul_0: 'DN commun',
  I00DIMLIGNEGAZ_in_typeCalcul_1: 'DN par tronçon',
  I00DIMLIGNEGAZ_SECTION_6_TITLE: 'Diamètre(s) réseau principal',
  I00DIMLIGNEGAZ_res_sectionPrincipale1: 'Diamètre compt à té ch1',
  I00DIMLIGNEGAZ_res_sectionPrincipale2: 'L2 ch1 - té ch2',
  I00DIMLIGNEGAZ_res_sectionPrincipale3: 'L3 ch2 - té ch3',
  I00DIMLIGNEGAZ_res_sectionPrincipale4: 'L4 ch3 - té ch4',
  I00DIMLIGNEGAZ_SECTION_7_TITLE: 'Diamètre(s) branche individuelle',
  I00DIMLIGNEGAZ_res_sectionSecondaire1: 'L ch1',
  I00DIMLIGNEGAZ_res_sectionSecondaire2: 'L ch2',
  I00DIMLIGNEGAZ_res_sectionSecondaire3: 'L ch3',
  I00DIMLIGNEGAZ_res_sectionSecondaire4: 'L ch4',
  I00DIMLIGNEGAZ_SECTION_8_TITLE: 'Volume bouteille',
  I00DIMLIGNEGAZ_res_volumeBouteille_error: 'Aucun volume nécessaire',
  I00DIMLIGNEGAZ_res_volumeBouteille: 'Volume bouteille',
  I00DIMLIGNEGAZ_MAIL_RESULT_TITLE0: 'Diamètre réseau principal',
  I00DIMLIGNEGAZ_MAIL_RESULT_TITLE1: 'Diamètre branche individuelle'
}
